import { paddingX, paddingY, typography } from "../../styles";
import { applyOpacity } from "../../styles/utils";
import styled from "styled-components";
export const Pill = styled.div<{
  small?: boolean;
}>`
  display: inline-flex;
  align-items: center;

  border-radius: 1rem;
  ${({
  small
}) => small ? paddingX.s : paddingX.m}
  ${paddingY.xs}
  background: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.05, true, theme.brand.cssVars["--d-surface"])};

  ${({
  small
}) => small ? typography.smallBold : typography.bodyBold}
  color: ${({
  theme
}) => theme.brand.cssVars["--d-text"]};
`;
export default Pill;